import _ from 'lodash'

export default {
  load() {
    if (! localStorage.getItem('saved')) return;
    
    try {
      let saved = JSON.parse(localStorage.getItem('saved'))
      if (! saved) return;

      return _.merge(this.saved, saved)
    }
    catch(e) {
      localStorage.clear()
    }
  },
  save(data) {
    localStorage.setItem('saved', JSON.stringify(data))
  },
  clear() {
    localStorage.clear()
  },
}
